import './index.scss'
import '../../assets/styles/language.css'
import '../../assets/scripts/trp-frontend-language-switcher.js'
import '../../assets/scripts/trp-language-cookie.js'
$("header").addClass("head1");
$(".hamburger").click(function(){
    $(this).toggleClass("active");
    $(".mob-nav").toggleClass("active");
})
$("header .nav li").hover(function(){
    $("header .nav li dl").stop().slideUp()
    $(this).find("dl").stop().slideDown()
}
,function(){
    $(this).find("dl").hide()
})
$(".mob-nav .nLi").click(function() {
    $(this).find(".sub").slideToggle();
    $(this).toggleClass("active");
})
 